
import mixins from "vue-typed-mixins"
import menuMixin from "@/mixins/menu"
import socialsMixin from "@/mixins/socials"

export default mixins(socialsMixin, menuMixin).extend({
  data: () => ({
    isFeedbackDialogOpen: false,
  }),
})
